/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { ReactElement, useCallback, useMemo } from 'react'
import { useSelectionContext } from './SelectionProvider'
import { Checkbox, Radio } from '@mantine/core'

export type SelectionInputProps = {
  value: number | string | string[]
}

function SelectionInput (props: SelectionInputProps): ReactElement {
  const { value } = props

  const {
    includes,
    multiple,
    toggle
  } = useSelectionContext()

  const isChecked = useMemo<boolean>(() => includes(value), [includes, value])

  const handleChange = useCallback(() => {
    toggle(value)
  }, [toggle, value])

  const Component = multiple ? Checkbox : Radio

  return (
    <Component
      checked={isChecked}
      onChange={handleChange}
      value={value}
    />
  )
}

export default SelectionInput
